<template>
    <div class="main">
        <div class="headeraa">
            <my-nav-bar title="话题列表"
                        background="#9A8CA5"
                        textColor="#FFF"
                        :bordered="false"
                        :style="style">
                <template v-slot:right>
                    <span class="iconfont icon-fenxiang"
                          @click="showFunc = true"></span>
                </template>
            </my-nav-bar>

            <div class="topicTit">
                <img class="topicImg"
                     :src="data.image"
                     alt="" />
                <span class="topTit">{{ data.title }}</span>
            </div>

        </div>

        <div class="topicContent"
             ref="topicContent">
            <div class="firstLine">
                <span>{{ data.views }}</span><span>{{ data.sum }}</span><span></span>
            </div>
            <div :class="['content', expande ? 'expande' : 'close']"
                 ref="content">
                {{ data.intro }}
            </div>

            <div class="lastLine">
                <!--          <div class="topciLeft">-->
                <!--            <img src="@/assets/img/yan.png" alt="" />-->
                <!--            <span style="margin-left: 1px">{{ data.views }}</span>-->
                <!--          </div>-->
                <span></span>
                <div class="topciRight"
                     v-if="isShow">
                    <div class="expande-button"
                         @click="expandeClick"
                         v-if="!expande">
                        展开
                    </div>
                    <div class="expande-button"
                         @click="expandeClick"
                         v-else>收起</div>
                    <img src="@/assets/img/zhankai.png"
                         alt="" />
                </div>
            </div>
        </div>

        <!-- 内容部分 -->
        <div class="list">
            <div class="post-tabs">
                <div :class="{'item': true, active: item.type == type}"
                     @click="changeTabs(item.type)"
                     v-for="item in tabs"
                     :key="item.type">{{ item.name }}</div>
            </div>
            <post-card v-for="(item, index) in list"
                       :key="index"
                       :dataSource="item"
                       :audio="audio"></post-card>
        </div>
        <div class="loading"
             v-if="!finished">
            <van-loading type="spinner"
                         size="16">加载更多...</van-loading>
        </div>
        <div v-else
             class="loading">没有更多了</div>
        <!-- 功能列表 -->
        <action-sheet v-model="showFunc"
                      @select="switchFunc"
                      cancel-text="取消">
            <div class="sheetContent">
                <div class="items"></div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import MyNavBar from "@/components/MyNavBar.vue";
import PostCard from "@/components/PostCard.vue";
import { getTopic, getGetTopicList } from "@/request/api.js";
import { Loading, ActionSheet, ImagePreview } from "vant";
export default {
    components: {
        ActionSheet,
        MyNavBar,
        PostCard,
        [Loading.name]: Loading,
    },
    data() {
        return {
            data: {},
            page: 1,
            type: 2,
            tabs: [
                { name: "最新", type: 2 },
                { name: "最热", type: 1 },
            ],
            showFunc: false,
            funcList: [
                [
                    { name: "朋友圈", icon: "wechat-moments" },
                    { name: "微信", icon: "wechat" },
                ],
            ],
            isLoading: false,
            finished: false,
            id: "", //话题id
            isShow: true, //是否显示展开组件
            list: [],
            expande: true,
            needShowExpande: false,
            scrollHeight: "",
            background: "",
            textColor: "",
            style: {},
            audio: null,
            timer: null,
        };
    },
    created() {
        // 开启下拉监听
        // this.pullDownListener(this.screenScroll);
    },
    mounted() {
        //   this.style.background = "#222"
        this.id = this.$route.query.id;
        this.initScroll();
        this.initTopic();
        this.initData();
        this.$nextTick(() => {
            let lineHeight = 22;
            if (this.$refs.content.offsetHeight > lineHeight * 3) {
                this.expande = false;
                this.needShowExpande = true;
            } else {
                this.expande = true;
            }
        });
        this.audio = document.createElement("AUDIO");
        document.body.append(this.audio);
    },
    methods: {
        expandeClick() {
            console.log("expandeClick");
            this.expande = !this.expande;
        },
        changeTabs(type) {
            this.type = type;
            this.resetList();
            // 获取数据
            this.initData();
        },
        // 重置参数
        resetList() {
            this.page = 1;
            this.list = [];
            this.finished = false
        },
        isElementInViewport(el) {
            //获取元素是否在可视区域
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <=
                    (window.innerHeight ||
                        document.documentElement.clientHeight) &&
                rect.right <=
                    (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        //获取话题详情
        initTopic() {
            getTopic({ id: this.id }).then((res) => {
                if (res.error_code == 0) {
                    console.log(res);
                    this.topicTitSrc = res.data.image;
                    this.data = res.data;
                    let tmp = res.data;
                    console.log(ULinkPullEntity);
                    this.$bus.$emit("linkDataUpdate", {
                        redirectPath: 16,
                        cid: tmp.id,
                    });
                      this.$bus.$emit("linkDataUpdateModel", {
                        redirectPath: 16,
                        cid: tmp.id,
                    });
                }
            });
        },
        initData() {
            if (this.isLoading || this.finished) return;
            this.isLoading = true;
            getGetTopicList({
                topic_id: this.id,
                page: this.page,
                sort: this.type,
            }).then((res) => {
                if (res.error_code == 0) {
                    if (this.page > 1) {
                        this.list = [...this.list, ...res.posts];
                    } else {
                        this.list = res.posts;
                    }
                    // 是否已完成
                    this.finished = res.posts.length < 8;
                }
                this.isLoading = false;
            });
        },
        screenScroll(data) {
            console.log(data);
        },
        // 下拉刷新事件
        initScroll() {
            let el = document.getElementsByClassName("loading")[0];
            console.log(el.offsetTop);
            //   return
            let height = window.innerHeight;
            window.addEventListener(
                "scroll",
                () => {
                    let offset = window.pageYOffset;
                    this.scrollHeight = window.pageYOffset;
                    // console.log('offset='+offset);
                    if (this.isElementInViewport(el)) {
                        if (!this.isLoading) {
                            if (this.timer) {
                                clearTimeout(this.timer);
                            }
                            this.timer = setTimeout(() => {
                                this.page++;
                                this.initData();
                            }, 300);
                        }
                    }
                },
                true
            );
        },
        switchFunc(e) {
            console.log(e);
        },
    },
    watch: {
        scrollHeight(val) {
            if (val > 300) {
                this.$nextTick(() => (this.background = "#fff"));
                // this.$nextTick(()=>this.textColor = "#000")
                // this.textColor = '#222'
                this.style.color = "#222";
            } else {
                this.background = "";
            }
        },
        //   background(val){
        //       if(val){
        //           console.log(val);
        //       }
        //   }
    },
};
</script>
<style lang="less">
* {
    margin: 0;
    padding: 0;
}
.sheetContent {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    .items {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
.post-tabs {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #222;
    margin-top: 10px;
    background-color: #fff;
    padding-bottom: 15px;
    .item {
        position: relative;
        &.active {
            color: #ff2f67;
            font-weight: bold;
            &::before {
                content: "";
                width: 70%;
                height: 5px;
                background-color: #ff2f67;
                border-radius: 5px;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -10px;
            }
        }
    }
}
.ellipsis3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 5px 0;
    color: #999999;
    font-size: 14px;
}
.title {
    //   color: #fff;
    font-size: 18px;
    line-height: 25px;
    .active {
        color: #222;
    }
}
.right,
.left {
    //   color: #fff;
    width: 24px;
    height: 24px;
}

.main {
    width: 100%;
    .list {
        margin-top: 50px;
        padding-left: 16px;
        padding-right: 16px;
    }
    .headeraa {
        width: 100vw;
        height: 243px;
        background-color: rgba(86, 64, 105, 0.6);
        // position: relative;
        // overflow: visible;

        .topicTit {
            //   position: absolute;
            //   left: 0;
            //   top: 20rpx;
            width: 100%;
            height: 84px;
            display: flex;
            flex-direction: row;
            padding-left: 32px;
            margin-top: 10px;
            .topicImg {
                width: 84px;
                height: 84px;
                border-radius: 6px;
                object-fit: cover;
                z-index: 999;
            }
            .topTit {
                margin-top: 17px;
                margin-left: 8px;
                color: #fff;
                font-size: 16px;
                line-height: 22px;
            }
        }
    }
    .topicContent {
        width: 92vw;
        min-height: 160px;
        background-color: #fff;
        border-radius: 6px;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.04);
        //   position: absolute;
        //   top: 105px;
        //   left: 4vw;
        display: flex;
        flex-direction: column;
        padding: 6px 16px 16px 16px;
        margin: auto;
        margin-top: -135px;
        //   margin-bottom: -120rpx;
        .firstLine {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 100px;
            font-size: 12px;
            color: #646464;
            line-height: 17px;
        }
        .content {
            margin-top: 13px;
            min-height: 83px;
            color: #222;
            font-size: 14px;
            line-height: 22px;
        }
        .lastLine {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 6px;
            .topciLeft,
            .topciRight {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 14px;
                color: #2e8cff;
            }
            .topciLeft {
                font-size: 12px;
                color: #a7a7a7;
                line-height: 17px;
            }
        }
    }
}
.content {
    font-size: 14px;
    color: black;
    letter-spacing: 0;
    line-height: 22px;
    text-align: justify;
    //   overflow: hidden;
    //   display: -webkit-box;
    //   -webkit-line-clamp: 3;
    //   -webkit-box-orient: vertical;
    //   text-overflow: ellipsis;
}

.expande {
    overflow: auto;
    height: auto;
    //   padding-bottom: 22px;
}

.close {
    overflow: hidden;
    height: 66px;
    padding-bottom: 0;
}

.expande-button-wrap {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 22px;
    background: white;
}

.expande-button {
    text-align: right;
    vertical-align: middle;
    color: #5995ef;
    font-size: 14px;
    line-height: 22px;
}
</style>
